document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initProducto();
  initStickyBar();
  initCountdown();
  initBarraStock();
  initViendo();
  initContadorFijo();
  initEnvioGratisBarra();
});

function initReveal() {
  var els = document.querySelectorAll('.gw-reveal, .gw-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('gw-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gw-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.gw-faq__item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.gw-faq__pregunta');
    var respuesta = item.querySelector('.gw-faq__respuesta');
    if (!btn || !respuesta) return;
    btn.addEventListener('click', function () {
      var abierta = item.classList.contains('gw-abierto');
      items.forEach(function (otro) {
        otro.classList.remove('gw-abierto');
        var r = otro.querySelector('.gw-faq__respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierta) {
        item.classList.add('gw-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initProducto() {
  var root = document.querySelector('[data-gw-producto]');
  if (!root) return;

  var dataEl = document.querySelector('[data-gw-variantes]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = root.querySelector('input[name="id"]');
  var precioEl = root.querySelector('[data-gw-precio]');
  var precioAntesEl = root.querySelector('[data-gw-precio-antes]');
  var ahorroEl = root.querySelector('[data-gw-ahorro]');
  var comprarBtn = root.querySelector('[data-gw-comprar]');
  var valores = root.querySelectorAll('.gw-opcion__valor');
  var minis = root.querySelectorAll('.gw-producto__mini');
  root.gwFotos = initCarruselFotos(root, minis);
  var principalImg = root.querySelector('[data-gw-principal-img]');
  var stickyPrecio = document.querySelector('[data-gw-sticky-precio]');
  var stickyPrecioAntes = document.querySelector('[data-gw-sticky-precio-antes]');
  var stickyComprar = document.querySelector('[data-gw-sticky-comprar]');
  var stickyImg = document.querySelector('[data-gw-sticky-img]');
  var stickyOpcion = document.querySelector('[data-gw-sticky-opcion]');

  // Los precios ya vienen formateados por Shopify en la moneda del mercado (€, $, £…)
  function precioFmt(v) { return v.price_fmt; }
  function antesFmt(v) { return v.compare_fmt; }

  function opcionesSeleccionadas() {
    var seleccion = [];
    root.querySelectorAll('.gw-opcion').forEach(function (grupo) {
      var activo = grupo.querySelector('.gw-opcion__valor.gw-seleccionada');
      seleccion.push(activo ? activo.dataset.valor : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = opcionesSeleccionadas();
    return variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = precioFmt(variante);
    if (precioAntesEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntesEl.textContent = antesFmt(variante);
        precioAntesEl.style.display = '';
        if (ahorroEl) {
          ahorroEl.textContent = (ahorroEl.dataset.texto || '') + ' ' + variante.ahorro_fmt;
          ahorroEl.style.display = '';
        }
      } else {
        precioAntesEl.style.display = 'none';
        if (ahorroEl) ahorroEl.style.display = 'none';
      }
    }
    if (comprarBtn) {
      // El texto vive en un <span> dentro del botón (junto al spinner de carga de Dawn);
      // tocar comprarBtn.textContent directamente borraría el spinner.
      var comprarTexto = comprarBtn.querySelector('span') || comprarBtn;
      if (variante.available) {
        comprarBtn.disabled = false;
        comprarBtn.removeAttribute('aria-disabled');
        comprarTexto.textContent = comprarBtn.dataset.textoDisponible || 'Añadir al carrito';
      } else {
        comprarBtn.disabled = true;
        comprarTexto.textContent = comprarBtn.dataset.textoAgotado || 'Agotado';
      }
    }
    if (variante.featured_media) {
      if (root.gwFotos && variante.featured_media.id) {
        root.gwFotos.irAMedio(variante.featured_media.id);
      } else if (principalImg) {
        principalImg.src = variante.featured_media.preview_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2');
      }
    }
    if (stickyPrecio) stickyPrecio.textContent = precioFmt(variante);
    if (stickyPrecioAntes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        stickyPrecioAntes.textContent = antesFmt(variante);
        stickyPrecioAntes.style.display = '';
      } else {
        stickyPrecioAntes.style.display = 'none';
      }
    }
    if (stickyComprar) {
      stickyComprar.disabled = !variante.available;
      var stickyTexto = stickyComprar.querySelector('span');
      if (stickyTexto) stickyTexto.textContent = variante.available ? (comprarBtn && comprarBtn.dataset.textoDisponible || 'Añadir al carrito') : (comprarBtn && comprarBtn.dataset.textoAgotado || 'Agotado');
    }
    if (stickyOpcion && variante.options) stickyOpcion.textContent = variante.options.join(' · ');
    if (stickyImg && variante.featured_media) {
      stickyImg.src = variante.featured_media.preview_image.src;
    }
  }

  valores.forEach(function (valor) {
    valor.addEventListener('click', function () {
      if (valor.hasAttribute('disabled')) return;
      var grupo = valor.closest('.gw-opcion');
      grupo.querySelectorAll('.gw-opcion__valor').forEach(function (v) { v.classList.remove('gw-seleccionada'); });
      valor.classList.add('gw-seleccionada');
      actualizar();
      actualizarExtras();
    });
  });

  // Enchufe según el país del cliente (Reino Unido, EE. UU./Canadá, Australia; el resto, Europa),
  // salvo que la URL ya traiga una variante concreta.
  if (root.hasAttribute('data-gw-enchufe-por-pais') && !/[?&]variant=/.test(location.search)) {
    var paisCliente = (window.Shopify && window.Shopify.country) || '';
    var idxEnchufe = { GB: 1, US: 2, CA: 2, AU: 3 }[paisCliente];
    var grupoEnchufe = [].slice.call(root.querySelectorAll('.gw-opcion')).filter(function (g) { return !g.classList.contains('gw-opcion--pack'); })[0];
    if (idxEnchufe && grupoEnchufe) {
      var botonesEnchufe = grupoEnchufe.querySelectorAll('.gw-opcion__valor');
      if (botonesEnchufe[idxEnchufe]) botonesEnchufe[idxEnchufe].click();
    }
  }

  var extras = root.querySelector('[data-gw-extras]');
  function actualizarExtras() {
    if (!extras) return;
    var cards = root.querySelectorAll('.gw-pack__card');
    var unidades = 1;
    cards.forEach(function (card, i) {
      if (card.classList.contains('gw-seleccionada')) unidades = i + 1;
    });
    var porUnidad = extras.hasAttribute('data-por-unidad');
    extras.hidden = porUnidad ? false : unidades < 2;
    if (porUnidad) {
      // el bloque de elección va justo debajo del pack seleccionado
      var sel = root.querySelector('.gw-pack__card.gw-seleccionada');
      if (sel && sel.nextElementSibling !== extras) sel.parentNode.insertBefore(extras, sel.nextSibling);
      var tit = extras.querySelector('[data-gw-extras-titulo]');
      if (tit) tit.textContent = unidades > 1 ? tit.dataset.varios : (tit.dataset.uno || tit.dataset.varios);
    }
    extras.querySelectorAll('[data-gw-extra-unidad]').forEach(function (fila) {
      var activa = parseInt(fila.dataset.gwExtraUnidad, 10) <= unidades;
      fila.hidden = !activa;
      var campo = fila.querySelector('[data-gw-extra-input]');
      if (campo) campo.disabled = !activa;
    });
  }
  actualizarExtras();

  // Carrusel de disfraces para los packs de 2 o 3: al elegir uno se guarda en el campo oculto que viaja con la compra
  if (extras) {
    extras.querySelectorAll('[data-gw-extra-unidad]').forEach(function (fila) {
      var campo = fila.querySelector('[data-gw-extra-input]');
      var pista = fila.querySelector('[data-gw-carrusel-pista]');
      fila.querySelectorAll('.gw-opc').forEach(function (opc) {
        opc.addEventListener('click', function () {
          fila.querySelectorAll('.gw-opc').forEach(function (o) { o.classList.remove('gw-opc--sel'); });
          opc.classList.add('gw-opc--sel');
          if (campo) campo.value = opc.dataset.valor;
          // Unidad 1: el diseño elegido es la variante que se compra (se pulsa la opción oculta de arriba)
          if (opc.dataset.op !== undefined) {
            var vals = opc.dataset.op.split('|');
            root.querySelectorAll('.gw-opcion:not(.gw-opcion--pack)').forEach(function (grupo, k) {
              var b = [].slice.call(grupo.querySelectorAll('.gw-opcion__valor')).find(function (x) { return x.dataset.valor === vals[k]; });
              if (b && !b.classList.contains('gw-seleccionada')) b.click();
            });
            var img = opc.querySelector('img');
            extras.querySelectorAll('[data-gw-foto-igual]').forEach(function (f) { if (img) f.src = img.src; });
          }
        });
      });
      fila.querySelectorAll('[data-gw-carrusel-flecha]').forEach(function (flecha) {
        flecha.addEventListener('click', function () {
          var dir = parseInt(flecha.dataset.gwCarruselFlecha, 10);
          pista.scrollBy({ left: dir * pista.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    });
  }

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      if (root.gwFotos && mini.dataset.indice !== undefined) { root.gwFotos.irA(parseInt(mini.dataset.indice, 10), true); return; }
      minis.forEach(function (m) { m.classList.remove('gw-activa'); });
      mini.classList.add('gw-activa');
      if (principalImg) principalImg.src = mini.dataset.full;
    });
  });

  var cantInput = root.querySelector('[data-gw-cant-input]');
  root.querySelectorAll('[data-gw-cant-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.dataset.gwCantBtn, 10);
      var val = Math.max(1, (parseInt(cantInput.value, 10) || 1) + delta);
      cantInput.value = val;
    });
  });
}

function initCountdown() {
  var el = document.querySelector('[data-gw-countdown]');
  if (!el) return;
  var diario = el.dataset.modo === 'diario';
  var objetivo = 0;
  if (!diario) {
    var fecha = el.dataset.fechaFin;
    if (!fecha) return;
    objetivo = new Date(fecha.replace(' ', 'T')).getTime();
    if (isNaN(objetivo)) return;
  }

  var diasEl = el.querySelector('[data-gw-dias]');
  var horasEl = el.querySelector('[data-gw-horas]');
  var minEl = el.querySelector('[data-gw-min]');
  var segEl = el.querySelector('[data-gw-seg]');

  function pad(n) { return String(n).padStart(2, '0'); }

  // Modo diario: siempre cuenta hasta la próxima medianoche de ESPAÑA (Europe/Madrid), esté donde esté el visitante.
  // A las 00:00 de España vuelve a 24 h.
  var fmtEs = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Madrid', hourCycle: 'h23',
    year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  });
  function partesEs(ts) {
    var p = {};
    fmtEs.formatToParts(new Date(ts)).forEach(function (x) { if (x.type !== 'literal') p[x.type] = parseInt(x.value, 10); });
    return p;
  }
  // Diferencia (ms) entre la hora de Madrid y UTC en un instante dado (incluye horario de verano)
  function desfaseEs(ts) {
    var p = partesEs(ts);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ts / 1000) * 1000;
  }
  function proximaMedianoche() {
    var ahora = Date.now();
    var p = partesEs(ahora);
    var medianocheComoUtc = Date.UTC(p.year, p.month - 1, p.day + 1, 0, 0, 0);
    var objetivo = medianocheComoUtc - desfaseEs(ahora);
    // Ajuste si entre ahora y medianoche cambia el horario de verano
    objetivo = medianocheComoUtc - desfaseEs(objetivo - 3600000);
    return objetivo;
  }

  function tick() {
    var restante = (diario ? proximaMedianoche() : objetivo) - Date.now();
    if (restante < 0) restante = 0;
    var dias = Math.floor(restante / 86400000);
    var horas = Math.floor((restante % 86400000) / 3600000);
    var min = Math.floor((restante % 3600000) / 60000);
    var seg = Math.floor((restante % 60000) / 1000);
    if (diasEl) diasEl.textContent = pad(dias);
    if (horasEl) horasEl.textContent = pad(horas);
    if (minEl) minEl.textContent = pad(min);
    if (segEl) segEl.textContent = pad(seg);
    if (!diario && restante <= 0) clearInterval(intervalo);
  }

  tick();
  var intervalo = setInterval(tick, 1000);
}

function initStickyBar() {
  var bar = document.querySelector('[data-gw-sticky]');
  var boton = document.querySelector('[data-gw-comprar]');
  if (!bar || !boton) return;
  // La franja de oferta fija tapa la parte de arriba de la pantalla: el botón cuenta como "fuera" en cuanto queda debajo de ella.
  var contador = document.querySelector('.gw-anuncio, [data-gw-countdown]');
  var tapa = Math.round((contador && contador.closest('.shopify-section') ? contador.closest('.shopify-section').getBoundingClientRect().height : 0) + 20);
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('gw-sticky--visible', !entry.isIntersecting && entry.boundingClientRect.top < tapa);
    });
  }, { threshold: 0, rootMargin: '-' + tapa + 'px 0px 0px 0px' });
  obs.observe(boton);
}

function initBarraStock() {
  var barras = document.querySelectorAll('[data-gw-barra]');
  if (!barras.length) return;
  barras.forEach(function (b) {
    b.style.setProperty('--gw-barra-pct', (parseFloat(b.getAttribute('data-porcentaje')) || 88) + '%');
  });
  if (!('IntersectionObserver' in window)) {
    barras.forEach(function (b) { b.classList.add('gw-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gw-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.6 });
  barras.forEach(function (b) { obs.observe(b); });
}

function initViendo() {
  document.querySelectorAll('[data-gw-viendo]').forEach(function (el) {
    var num = el.querySelector('[data-gw-viendo-num]');
    if (!num) return;
    var inicial = parseInt(el.getAttribute('data-inicial'), 10) || 22;
    var tope = parseInt(el.getAttribute('data-tope'), 10) || 40;
    var actual = inicial;
    var inc = parseInt(el.getAttribute('data-incremento'), 10) || 2;
    var seg = parseInt(el.getAttribute('data-intervalo'), 10) || 5;
    function paso() {
      actual += inc;
      if (actual > tope) actual = inicial;
      num.textContent = actual;
      // pequeño "latido" del número para que se note el cambio
      num.classList.remove('gw-viendo--cambio'); void num.offsetWidth; num.classList.add('gw-viendo--cambio');
    }
    setTimeout(function () { paso(); setInterval(paso, seg * 1000); }, 3000);
  });
}

function initContadorFijo() {
  var barra = document.querySelector('.gw-anuncio__top--fijo');
  if (!barra) return;
  var contenedor = barra.closest('.shopify-section') || barra;
  function medir() {
    document.documentElement.style.setProperty('--gw-contador-alto', contenedor.offsetHeight + 'px');
  }
  medir();
  if ('ResizeObserver' in window) new ResizeObserver(medir).observe(contenedor);
  else window.addEventListener('resize', medir);
}

// Barra de "envío gratis" dentro del carrito lateral: se vuelve a calcular y a animar cada
// vez que cambia el contenido del carrito (Dawn reescribe el carrito entero en cada cambio,
// así que no hace falta escuchar cada botón +/-/añadir por separado: basta con vigilar el
// propio carrito con un MutationObserver).
function initEnvioGratisBarra() {
  var el = document.querySelector('[data-gw-envio-barra]');
  if (!el) return;
  var pct = parseFloat(el.getAttribute('data-porcentaje'));
  if (isNaN(pct)) pct = 0;
  el.style.setProperty('--gw-envio-pct', pct + '%');
  el.classList.remove('gw-visible');
  // Fuerza un reflow para que el navegador "olvide" el estado anterior y la transición
  // de relleno se vuelva a reproducir cada vez, aunque el porcentaje no haya cambiado.
  void el.offsetWidth;
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      el.classList.add('gw-visible');
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && 'MutationObserver' in window) {
    var reintento;
    new MutationObserver(function () {
      clearTimeout(reintento);
      reintento = setTimeout(initEnvioGratisBarra, 80);
    }).observe(cartDrawer, { childList: true, subtree: true });
  }
});


/* Carrusel de fotos del producto: pasa solo cada N segundos, se puede deslizar con el dedo
   y se pausa unos segundos cuando el cliente toca una foto, una miniatura o elige un diseño. */
function initCarruselFotos(root, minis) {
  var caja = root.querySelector('[data-gw-fotos]');
  var pista = caja && caja.querySelector('[data-gw-fotos-pista]');
  if (!pista) return null;
  var slides = pista.querySelectorAll('.gw-fotos__slide');
  var n = slides.length, actual = parseInt(caja.getAttribute('data-inicio'), 10) || 0;
  var auto = caja.getAttribute('data-auto') === 'true' && n > 1;
  var ms = (parseFloat(caja.getAttribute('data-segundos')) || 2) * 1000;
  var pausaHasta = 0, timer = null;
  function marcar(i) {
    minis.forEach(function (m) { m.classList.toggle('gw-activa', parseInt(m.dataset.indice, 10) === i); });
    var activa = minis[i];
    var fila = activa && activa.parentElement;
    if (fila && fila.scrollWidth > fila.clientWidth) {
      fila.scrollTo({ left: activa.offsetLeft - fila.clientWidth / 2 + activa.clientWidth / 2, behavior: 'smooth' });
    }
  }
  function irA(i, manual) {
    actual = (i + n) % n;
    pista.scrollTo({ left: actual * pista.clientWidth, behavior: 'smooth' });
    marcar(actual);
    if (manual) pausar();
  }
  function pausar() { pausaHasta = Date.now() + 6000; }
  function irAMedio(id) {
    for (var i = 0; i < n; i++) { if (String(slides[i].dataset.mediaId) === String(id)) { if (i !== actual) irA(i, true); return; } }
  }
  if (actual) pista.scrollLeft = actual * pista.clientWidth;
  // al deslizar con el dedo se actualiza la miniatura activa
  var t;
  pista.addEventListener('scroll', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var i = Math.round(pista.scrollLeft / pista.clientWidth);
      if (i !== actual) { actual = i; marcar(i); }
    }, 80);
  }, { passive: true });
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { pista.addEventListener(ev, pausar, { passive: true }); });
  caja.addEventListener('mouseenter', function () { pausaHasta = Infinity; });
  caja.addEventListener('mouseleave', function () { pausaHasta = Date.now() + 1500; });
  if (auto) {
    timer = setInterval(function () {
      if (document.hidden || Date.now() < pausaHasta) return;
      irA(actual + 1, false);
    }, ms);
  }
  return { irA: irA, irAMedio: irAMedio };
}

/* Extras del carrito: al marcar/desmarcar una casilla se añade/quita el producto y se repinta el carrito lateral */
document.addEventListener('change', function (e) {
  var t = e.target && e.target.closest ? e.target.closest('[data-gw-extra-toggle]') : null;
  if (!t) return;
  var id = parseInt(t.getAttribute('data-variant-id'), 10);
  var drawer = document.querySelector('cart-drawer');
  var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  t.disabled = true;
  var peticion = t.checked
    ? fetch(raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: secciones }) })
    : fetch(raiz + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: 0, sections: secciones }) });
  peticion.then(function (r) { return r.json(); }).then(function (estado) {
    if (drawer && estado.sections) { drawer.renderContents({ id: null, sections: estado.sections }); }
    else { window.location.reload(); }
  }).catch(function () { t.checked = !t.checked; t.disabled = false; });
});
